import { post, get } from "../util/crmAxios";

//模板库-列表查询
export const queryActivityTemplateListByPage = (params) =>
  post("crm/activity/queryActivityTemplateListByPage", params);
//模板库-标签查询
export const queryLabels = (params) => get("crm/label/queryLabels", params);
//模板库-获取单个模版内容
export const getActivityTemplateInfo = (params) =>
  post("crm/activity/getActivityTemplateInfo", params);
//模板库-获取登录人获取机构信息
export const getAgencyInfo = (params) =>
  get("base/agency/getAgencyInfo", params);
//模板库-获取活动配置
export const getActivityConfig = (params) =>
  get("crm/activity/getActivityConfig", params);
//模板库-获取活动信息
export const getActivityInfo = (params) =>
  post("crm/activity/getActivityInfo", params);
//模板库-上传图片
export const uploadPicture = (params) =>
  post("base/upload/uploadPicture", params);
//模板库-检测敏感词
export const isContainSensitiveWord = (params) =>
  post("sensitiveWord/isContainSensitiveWord", params);
//模板库-保存活动信息
export const createOrUpdateActivity = (params) =>
  post("crm/activity/createOrUpdateActivity", params);

//校区活动-查询所有创建的校区活动
export const queryActivityListByPage = (params) =>
  post("crm/activity/queryActivityListByPage", params);
//校区活动-上架下架活动
export const activityUpdateStatus = (params) =>
  post("crm/activity/activityUpdateStatus", params);
//校区活动-删除活动
export const activityDelete = (params) =>
  post("crm/activity/activityDelete", params);
//校区活动-活动参与情况列表展示
export const getManagerInfo = (params) =>
  get("crm/activity/getManagerInfo", params);
//校区活动-活动参与情况列表
export const selectActivityUsers = (params) =>
  post("crm/activity/selectActivityUsers", params);
//校区活动-活动参与情况导出
export const exportActivityUserList = (params) =>
  post("crm/activity/exportActivityUserList", params);

//每日营销-列表查询
export const dailyPicList = (params) =>
  post("crm/dailyPicture/dailyPicList", params);
//每日营销-删除每日一图
export const deleteDailyPic = (params) =>
  post("crm/dailyPicture/deleteDailyPic", params);
//转介绍-列表查询
export const selectTurnIntroduceList = (params) =>
  post("crm/activity/selectTurnIntroduceList", params);
//转介绍-参与学员列表查询
export const selectPosterUsersList = (params) =>
  post("crm/activity/selectPosterUsersList", params);
//转介绍-参与详情列表查询
export const selectUserActions = (params) =>
  post("crm/action/selectUserActions", params);

export const addDailyPic = (params) =>
  post("crm/dailyPicture/addDailyPic", params);

//模板库-标签查询
export const queryParentLabels = (params) => get("crm/label/queryParentLabels", params);
